<template>
    <div class="c c-dealers">
        <DealerModule v-if="settings.culture === 'nl-NL'" assetsFolder="/Assets/Images/dealers" apiUrl="" apiKey="AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k" translationsUrl="/umbraco/api/translations/getalltranslations?locale=nl-NL&dictionaryKey=Dealers" :culture="settings.culture" numberOfResults="5" showFilters>
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>
        </DealerModule>
        <DealerModule v-if="settings.culture === 'en'" assetsFolder="/Assets/Images/dealers" apiUrl="" apiKey="AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k" translationsUrl="/umbraco/api/translations/getalltranslations?locale=en&dictionaryKey=Dealers" :culture="settings.culture" numberOfResults="5" showFilters>
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>
        </DealerModule>
        <DealerModule v-if="settings.culture === 'en-GB'" assetsFolder="/Assets/Images/dealers" apiUrl="" apiKey="AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k" translationsUrl="/umbraco/api/translations/getalltranslations?locale=en-GB&dictionaryKey=Dealers" :culture="settings.culture" numberOfResults="5">
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>
        </DealerModule>
        <DealerModule v-if="settings.culture === 'nl-BE'" assetsFolder="/Assets/Images/dealers" apiUrl="" apiKey="AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k" translationsUrl="/umbraco/api/translations/getalltranslations?locale=nl-BE&dictionaryKey=Dealers" :culture="settings.culture" numberOfResults="5" showFilters>
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>
        </DealerModule>
        <DealerModule v-if="settings.culture === 'fr-BE'" assetsFolder="/Assets/Images/dealers" apiUrl="" apiKey="AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k" translationsUrl="/umbraco/api/translations/getalltranslations?locale=fr-BE&dictionaryKey=Dealers" :culture="settings.culture" numberOfResults="5" showFilters>
            <template #searchButton="searchButton">
                <button class="btn btn-primary"
                        type="button"
                        id="searchform"
                        @click="searchButton.search(searchButton.localSearchTerm)">
                    <i class="far fa-search"></i>
                </button>
            </template>
        </DealerModule>
    </div>
</template>

<script>
    import { DealerModule } from '@frontisbv/frontisdealermodule';

    export default {
        components: {
            DealerModule
        },
        data() {
            return {
            };
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        }
    };
</script>
